<template>
    <div class="college-app-main">
<!--        <section class="dashboard-nav">-->
            <div class="theme-layout" id="scrollup">
                <div class="responsive-header">
                    <div class="responsive-menubar">
                        <div class="res-logo">
                            <router-link to="/">
                                <img v-bind:src="logo">
                            </router-link>
                        </div>
                        <div class="menu-resaction">
                            <div class="res-openmenu" @click="openMobileMenu()">
                                <img src="images/icon.png" alt=""/> Menu
                            </div>
                            <div class="res-closemenu" @click="closeMobileMenu()">
                                <img src="images/icon2.png" alt=""/> Close
                            </div>
                        </div>
                    </div>
                    <div class="responsive-opensec">
                        <div class="btn-extars">
                            <ul class="account-btns" v-if="loggedIn">
                                <li class="signup-popup" v-on:click="logoutClicked">
                                    <i class="fas fa-sign-out-alt"></i> Logout
                                </li>
                            </ul>
                        </div>
                        <div class="responsivemenu" v-if="this.$store.getters.getUserType != 'teacher'">
                            <ul v-if="loggedIn">
                                <li v-if="this.$store.getters.getUser['business_activity'] != 'School'" @click="closeMobileMenu()">
                                    <router-link to="/dashboard/viewcompanies">Companies</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_jobs']" @click="closeMobileMenu()">
                                    <router-link to="/dashboard/all-jobs">Jobs</router-link>
                                </li>
                                <li v-if="this.$store.getters.getPreferences['show_internships']" @click="closeMobileMenu()">
                                    <router-link to="/dashboard/all-internships">Internships</router-link>
                                </li>
                                <li @click="closeMobileMenu()">
                                    <router-link to="/dashboard/viewcandidates">Students</router-link>
                                </li>
                                <li v-if="this.$store.getters.getUser['education_loan']" @click="closeMobileMenu()">
                                    <router-link to="/dashboard/loan-applicants">Education Loan</router-link>
                                </li>
                                <li @click="closeMobileMenu()">
                                  <router-link to="/dashboard/webinars">Webinars</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <header class="stick-top forsticky">
                    <div class="menu-sec">
                        <div class="container">
                            <div class="logo">
                                <router-link to="/">
                                    <img class="hidesticky" v-bind:src="logo">
                                    <img class="showsticky" v-bind:src="logo">
                                </router-link>
                            </div><!-- Logo -->

<!--                            <div class="btn-extars" v-if="loggedIn">-->
<!--                                <ul class="account-btns" v-on:click="logoutClicked">-->
<!--                                    <li><i class="fas fa-sign-out-alt"></i> Logout</li>-->
<!--                                </ul>-->
<!--                            </div>-->

                            <nav>
                                <!--<ul v-if="loggedIn">-->
                                <ul v-if="this.$store.getters.getUserType != 'teacher'">
                                    <li v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                        <router-link to="/dashboard/viewcompanies">Companies</router-link>
                                    </li>
                                    <li v-if="this.$store.getters.getPreferences['show_jobs']">
                                        <router-link to="/dashboard/all-jobs">Jobs</router-link>
                                    </li>
                                    <li v-if="this.$store.getters.getPreferences['show_internships']">
                                        <router-link to="/dashboard/all-internships">Internships</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/dashboard/viewcandidates">Students</router-link>
                                    </li>
                                    <li v-if="this.$store.getters.getUser['education_loan']">
                                        <router-link to="/dashboard/loan-applicants">Education Loan</router-link>
                                    </li>
                                    <li>
                                      <router-link to="/dashboard/webinars">Webinars</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/quizzes">Quizzes</router-link>
                                    </li>
                                </ul>
                            </nav><!-- Menus -->
                        </div>
                    </div>
                </header>
            </div>
<!--        </section>-->
        <section class="college-details">
            <router-view></router-view>
       </section>
    </div>
</template>

<script>
    import login from './../Login.vue'
    import toastr from "../../../public/js/toastr";

    export default {
        components: {
            login
        },
        data: function () {
            return {
                logo: "/images/e_campus_logo.png",
            }
        },
        mounted() {

        },
        methods: {
            // openLoginModal() {
            //     $('#myModal').css({"display": "block"});
            // },
            logoutClicked() {
                this.$store.dispatch("setLoggedOut");
                toastr.success('Logging out soon', 'Logged Out');
                window.location.replace("/");
            },
            openMobileMenu() {
                $('.responsive-header').addClass('active');
                $('.responsive-opensec').slideDown();
                $('.res-closemenu').removeClass('active')
                $('.res-openmenu').addClass('active');
            },
            closeMobileMenu() {
                console.log('enter mobile close');
                $('.responsive-header').removeClass('active');
                $('.responsive-opensec').slideUp();
                $('.res-openmenu').removeClass('active')
                $('.res-closemenu').addClass('active');
            },
            // dashboard_click(){
            //     this.$router.push({path: '/dashboard'})
            // }
        },
        computed: {
            loggedIn: function () {
                return this.$store.getters.getAuthState;
            }
        }
    }

</script>

<style scoped>
    .dashboard-nav{
        position: relative;
        min-height: 80px;
    }
    .dash-btn{
        float: left;
        font-size: 16px;
        color: #000;
        position: relative;
        padding: 14px 20px;
        background: none;
        border:none;
    }
    .forsticky.sticky .menu-sec nav > ul > li > a{
        line-height: 20px !important;
    }
    .modal{
        z-index: 99;
    }
</style>